import LocalOffer from "@material-ui/icons/LocalOffer";
import Store from "@material-ui/icons/Store";
import Update from "@material-ui/icons/Update";
import LocalMall from "@material-ui/icons/LocalMall";
import React from 'react';

export async function getDistance(la1,lon1,la2,lon2)
{ 
    let ApiURL = "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&";
    let params = `origins=${la1},${lon1}&destinations=${la2},${lon2}&key=AIzaSyBEcPnjKk_2f_8NIHc-mfYKT9ft-CCz_HM`;  
    let finalApiURL = `${ApiURL}${encodeURI(params)}`;
return fetch(finalApiURL)  // return this promise
    .then(response => response.json())
    .then(json => (json.results))
}


export const DASHBOARD_ITEMS = {
    admin: [
        {
            title: "Vendors",
            desc: "More Info",
            icon: <Store/>,
            descIcon: <LocalOffer/>
        },
        {
            title: "Orders",
            desc: "List Of Orders",
            icon: <Store/>,
            descIcon: <LocalOffer/>
        },
        {
            title: "Users",
            desc: "List Of Users",
            icon: <Store/>,
            descIcon: <Update/>
        },
        {
            title: "Super Categories",
            desc: "List Of Super Categories",
            icon: <Store/>,
            descIcon: <LocalOffer/>
        }
    ],
    vendor: [
        {
            title: "Products",
            desc: "List Of Products",
            icon: <LocalMall/>,
            descIcon: <LocalMall/>
        },
        {
            title: "Orders",
            desc: "List Of Orders",
            icon: <Store/>,
            descIcon: <LocalOffer/>
        },
        {
            title: "Super Categories",
            desc: "List Of Super Categories",
            icon: <Store/>,
            descIcon: <LocalMall/>
        }
    ]
}

export const ORDER_STATUS = [
    {
        value: -1,
        label: 'All'
    },{
        value: 0,
        label: 'Received'
    },
    {
        value: 1,
        label: 'Approve order'
    },
    {
        value: 2,
        label: 'Reject order'
    },
    {
        value: 3,
        label: 'Preparing Order',
    },
    {
        value: 4,
        label: 'Out for Delivery'
    },
    {
        value: 5,
        label: 'Delivered'
    }
]

export const ORDER_STATUS_DRIVER = [
    {
        value: -1,
        label: 'All'
    },
    {
        value: 3,
        label: 'Preparing Order',
    },
    {
        value: 4,
        label: 'Out for Delivery'
    },
    {
        value: 5,
        label: 'Delivered'
    }
]

export const ORDER_STATUS_RECEIVED = [
    {
        key: 0,
        value: 'Order Received',
        label: 'Received'
    },
    {
        key: 1,
        value: 'Order Accepted',
        label: 'Approve order'
    },
    {
        key: 2,
        value: 'Order Rejected',
        label: 'Reject order'
    },
    {
        key: 3,
        value: 'Order Preparing',
        label: 'Preparing Order',
    },
    {
        key: 4,
        value: 'Out for Delivery',
        label: 'Out for Delivery'
    },
    {
        key: 5,
        value: 'Delivered',
        label: 'Delivered'
    }
]

export const ORDER_STATUS_RECEIVED_DRIVER = [
    {
        key: 3,
        value: 'Order Preparing',
        label: 'Preparing Order',
    },
    {
        key: 4,
        value: 'Out for Delivery',
        label: 'Out for Delivery'
    },
    {
        key: 5,
        value: 'Delivered',
        label: 'Delivered'
    }
]